import SiteFooter from '@/components/pageLayout/site-footer/site-footer';
import Old_SiteHeader from '@/components/pageLayout/site-header/old_site-header';

import GoogleAd from '@/components/ads/google-ads';
import Jobs from '@/components/pageLayout/jobs-az';
import SearchJob from '@/components/pageLayout/search-job';
import SiteBreadCrumbs from '@/components/pageLayout/site-breadcrumbs';
import SEOHead from '@/components/seo-head';
import JobService from '@/services/Job.service';
import { GetServerSidePropsContext } from 'next';

export default function JobsAZ(props: { jobsAZ: any; letter: string }) {
  const { jobsAZ, letter } = props;
  const letterUpperCase = letter.toUpperCase();

  return (
    <div className="page-jobs-a-z">
      <SEOHead
        description={`Letra ${letterUpperCase} - Vagas de empregos de A a Z, organizadas de forma prática e fácil para você encontrar sua oportunidade de trabalho. Acesse já!`}
        title={`Letra ${letterUpperCase} - Índice de Vagas de Empregos - O Amarelinho`}
        canonicalUrl={`https://oamarelinho.com.br/vagas/vagas-az/${letter}`}
        ogTitle={`Letra ${letterUpperCase} - Índice de Vagas de Empregos`}
        twitterTitle={`Letra ${letterUpperCase} - Índice de Vagas de Empregos`}
      >
        <meta name="robots" content="index,follow" />
      </SEOHead>

      <Old_SiteHeader />

      <main>
        <div className="banner banner-vagas">
          <div className="banner-content">
            <div className="container">
              <div className="row">
                <div className="col-12 banner-text-center d-flex flex-column justify-content-start justify-content-md-center">
                  <h1>Empregos de A - Z</h1>
                  <div className="banner-box">
                    <SearchJob />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container page-content page-content-after-banner">
          <SiteBreadCrumbs name={letter.toUpperCase()} />
          <GoogleAd
            format="horizontal"
            fullWidthResponsive={false}
            slot="5993932940"
            googleAdId="ca-pub-9646893046773308"
          />
          <Jobs jobsAZ={jobsAZ} redirect={true} letter={letter} />
          <GoogleAd slot="5993932940" googleAdId="ca-pub-9646893046773308" />
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  if (!context.resolvedUrl) {
    console.log('JobsAZ.getServerSideProps', { resolvedUrl: context.resolvedUrl });
  }
  const [, afterVagasAZ] = context.resolvedUrl.split(`/vagas-az/`);

  const [letter] = afterVagasAZ;

  if (context.query.in) {
    return {
      redirect: {
        permanent: true,
        destination: `/vagas/vagas-az/${context.query.in}`,
      },
    };
  } else {
    const jobsAZ = await JobService.fetchAZJobs(false);

    return {
      props: {
        jobsAZ,
        letter: letter || `a`,
      }, // will be passed to the page component as props
    };
  }
}
